module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "basic-text-frame"
  }, [_c('p', {
    staticClass: "structure-next"
  }), _vm._v(" "), _c('p', {
    staticClass: "chapsoy-title"
  }), _vm._v(" "), _c('p', {
    staticClass: "chapsoy-title"
  }), _vm._v(" "), _c('p', {
    staticClass: "chapsoy-title"
  }), _vm._v(" "), _c('p', {
    staticClass: "chapsoy-title"
  }), _vm._v(" "), _c('p', {
    staticClass: "chapsoy-title"
  }), _vm._v(" "), _c('p', {
    staticClass: "chapsoy-title"
  }), _vm._v(" "), _c('p', {
    staticClass: "chapsoy-title"
  }), _vm._v(" "), _c('p', {
    staticClass: "chapsoy-title"
  }), _vm._v(" "), _c('p', {
    staticClass: "chapsoy-title"
  }), _vm._v(" "), _c('p', {
    staticClass: "chapsoy-title"
  }), _vm._v(" "), _c('p', {
    staticClass: "chapsoy-title"
  }), _vm._v(" "), _c('p', {
    staticClass: "chapsoy-title"
  }), _vm._v(" "), _c('p', {
    staticClass: "paragraph-style"
  }, [_c('span', {
    staticClass: "qoutes"
  }, [_vm._v("“")]), _c('span', {
    staticClass: "char-style-override"
  }, [_vm._v("A")]), _vm._v("  man who views the world the same at fifty as he  did at twenty has wasted thirty years of his life.”")]), _vm._v(" "), _c('p', {
    staticClass: "chapsoy-title"
  }), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("- Muhammad Ali")]), _vm._v(" "), _c('div', {
    staticClass: "calibre1",
    attrs: {
      "id": "calibre_pb_2"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76025f6e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/NGJobHacks_split_002.vue
// module id = 63
// module chunks = 0